var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15103 2.35861L2.90589 0.913864C2.76235 0.747376 2.49919 0.748116 2.33246 0.916084L1.30853 1.9472C1.00378 2.2539 0.916554 2.70934 1.09285 3.0745C2.14609 5.26658 3.90481 7.03694 6.08405 8.09873C6.44696 8.27595 6.89967 8.18826 7.20442 7.88156L8.23792 6.84082C8.40538 6.67249 8.40575 6.40648 8.23865 6.26219L6.79587 5.01723C6.64497 4.887 6.41052 4.90402 6.25925 5.05645L5.75722 5.56183C5.73152 5.58891 5.69769 5.60675 5.66092 5.61264C5.62415 5.61852 5.58648 5.61211 5.55369 5.59439C4.73309 5.11938 4.05238 4.43424 3.58091 3.60874C3.56325 3.57572 3.55686 3.53779 3.56271 3.50077C3.56856 3.46375 3.58633 3.42967 3.6133 3.40378L4.11385 2.90025C4.26549 2.74708 4.28205 2.5103 4.15103 2.35824V2.35861Z",
    stroke: "currentColor",
    strokeWidth: 0.736111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.83333,
    height: 8.87934,
    fill: "currentColor",
    transform: "translate(0.266724 0.0500488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinePhone);
export default __webpack_public_path__ + "static/media/line-phone.4768f7fa5dd93ac6d366217aaaeda879.svg";
export { ForwardRef as ReactComponent };